import withErrorHandler from "component/design-system/withErrorHandler";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import styles from "./makeModelLink.module.scss";

function MakeModelLinks(props: any) {
  const { makeModels, handleProductOverviewSectionExpand } = props;
  const { t } = useTranslation("product");

  return (
    <div id="makeModels">

      <div className={styles.make_model_content}>

        <p>
          {t("make_model_fit")}
          {
            makeModels
              .filter((_: any) => _.pageDetails)
              .map((_: any, index: any) => {
                const linkText = `${_.pageDetails.pageDisplayableTitle.replace(/parts|& parts|Parts/, "").trim()}${index === makeModels.length - 1 ? "." : ","} `;

                return (
                  (<Link
                    href={_.url}
                    key={_.url}
                    title={`Revamp your vehicle with ${linkText} parts`}>

                    {linkText}

                  </Link>)
                );
              })
          }
        </p>
      </div>

      <div
        onClick={() => handleProductOverviewSectionExpand("FITTINGVEHICLE")}
        className={styles.see_more}
      >
        {t("See more")}
        &nbsp;
        &gt;
      </div>
    </div>
  );
}

export default withErrorHandler(MakeModelLinks);
